import { cn } from '@glade-ai/ui';
import { useEffect, useRef, useState } from 'react';

import MagnifyingGlass from '@/components/Icons/MagnifyingGlass';

import s from './SearchInput.module.scss';

const SearchInput: React.FC<{
  label: string;
  autoComplete?: string;
  placeholder?: string;
  setSearch: (search: string) => void;
  className?: string;
  autoFocus?: boolean;
  hideLabel?: boolean;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}> = ({ label, autoComplete, placeholder, setSearch, className, autoFocus, hideLabel, onKeyDown }) => {
  const [innerSearch, setInnerSearch] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const handler = setTimeout(() => {
      setSearch(innerSearch);
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, [innerSearch, setSearch]);

  // TODO(will): Why didn’t `autoFocus` work here?
  useEffect(() => {
    let frameId: number | null = null;
    frameId = requestAnimationFrame(() => {
      if (autoFocus && inputRef.current) {
        inputRef.current.focus();
      }
    });
    return () => {
      if (frameId !== null) cancelAnimationFrame(frameId);
    };
  }, [autoFocus]);

  return (
    <label className={cn(s.search, hideLabel && s.searchWithIcon, className)}>
      {hideLabel ? <MagnifyingGlass size={16} /> : label}
      <input
        ref={inputRef}
        name='search'
        type='search'
        placeholder={placeholder}
        autoComplete={autoComplete ? 'on' : 'off'}
        onChange={(e) => setInnerSearch(e.target.value)}
        onKeyDown={onKeyDown}
        className='focus-ring'
      />
    </label>
  );
};

export default SearchInput;
